import { useMemo } from 'react';
import FilterPlate from '..';
import { FILTER_CLAUSE } from '../constants';
import TypedFieldCTime from 'src/components/ui/TypedField/connectors/TypedFieldCTime';
import RangeDateField from 'src/components/ui/RangeDateField';
import { useFilter } from 'src/hooks/filters/useFilter';
import PropTypes from 'prop-types';

const FilterPlateCDate = (props) => {
	const { initialSelected, operator, onSubmit, ...rest } = props;

	const options = useMemo(() => {
		return [
			{ label: 'За последние', value: FILTER_CLAUSE.last },
			{ label: 'Больше', value: FILTER_CLAUSE.more },
			{ label: 'Меньше', value: FILTER_CLAUSE.less },
			{ label: 'В диапазоне', value: FILTER_CLAUSE.between },
		];
	}, []);

	const {
		handleOptionChange,
		handleSubmit,
		handleValueChange,
		setError,
		error,
		selectedValue,
		selectedOption,
	} = useFilter(options, initialSelected, operator, onSubmit, 'date');

	let uiNode;
	switch (selectedOption?.value) {
		case FILTER_CLAUSE.between:
			uiNode = (
				<RangeDateField
					value={selectedValue}
					onChange={handleValueChange}
				/>
			);
			break;
		case FILTER_CLAUSE.last:
			uiNode = (
				<TypedFieldCTime
					isSimpleOptions
					value={selectedValue}
					initialValue={selectedValue}
					errorMsg={error.message}
					setError={setError}
					onChange={handleValueChange}
				/>
			);
			break;
		default:
			uiNode = (
				<TypedFieldCTime
					value={selectedValue}
					errorMsg={error.message}
					setError={setError}
					onChange={handleValueChange}
				/>
			);
	}

	return (
		<FilterPlate
			typeSelector={{
				value: selectedOption,
				selectOnly: true,
				disableClearable: true,
				onChange: handleOptionChange,
				options,
			}}
			uiNode={uiNode}
			onSubmit={handleSubmit}
			isError={error.isError}
			{...rest}
		/>
	);
};

FilterPlateCDate.propTypes = {
	...FilterPlate.propTypes,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	operator: PropTypes.string,
};

export default FilterPlateCDate;
